import { useContext } from 'react'
import { GlobalContext } from '../../context/Context';
import { MySpace, Organization, Team } from '../icons/nav-icon';


const useNav = () => {
    let { state } = useContext(GlobalContext);
    const navList = {
        // TOP HEADER NAV
        topHeaderNav: [
            { name: 'My Space', icon: MySpace, url: '/my-space/overview', activeKey: "my-space" },
            { name: 'Team', icon: Team, url: '', activeKey: "team" },
            (state?.user?.mainRole == "admin" || state.user?.department == 13) && { name: 'Organization', icon: Organization, url: '', activeKey: "organization" },
        ].filter(Boolean),

        // BOTTOM HEADER NAV
        mySpaceBottomNav: [
            { name: "Overview", url: "/my-space/overview", activeKey: "overview" },
            { name: "Dashboard", url: "", activeKey: "dashboard" },
            { name: "Calendar", url: "", activeKey: "calendar" }
        ].filter(Boolean),

        PPCTopNav: [
            // { name: 'My Space', icon: MySpace, url: '', activeKey: "my-space" },
            // { name: 'Team', icon: Team, url: '', activeKey: "team" },
            { name: 'Organization', icon: Organization, url: '/ppc/organization/overview', activeKey: "organization" },
        ].filter(Boolean),

        PPCDataTopNav: [
            // { name: 'My Space', icon: MySpace, url: '', activeKey: "my-space" },
            // { name: 'Team', icon: Team, url: '', activeKey: "team" },
            { name: 'Organization', icon: Organization, url: '/ppc-data/organization/data', activeKey: "organization" },
        ].filter(Boolean),

        ProductSummaryTopNav: [
            // { name: 'My Space', icon: MySpace, url: '', activeKey: "my-space" },
            // { name: 'Team', icon: Team, url: '', activeKey: "team" },
            { name: 'Summary', icon: Organization, url: '/product-summary/summary/products', activeKey: "summary" },
        ].filter(Boolean),

        PlatformSummaryTopNav: [
            // { name: 'My Space', icon: MySpace, url: '', activeKey: "my-space" },
            // { name: 'Team', icon: Team, url: '', activeKey: "team" },
            { name: 'Summary', icon: Organization, url: '/platform-summary/summary/platforms', activeKey: "summary" },
        ].filter(Boolean),

        MainSummaryTopNav: [
            // { name: 'My Space', icon: MySpace, url: '', activeKey: "my-space" },
            // { name: 'Team', icon: Team, url: '', activeKey: "team" },
            { name: 'Product', icon: Organization, url: '/summary/product/products', activeKey: "product" },
            { name: 'Platform', icon: Organization, url: '/summary/platform/platforms', activeKey: "platform" },
            { name: 'Device', icon: Organization, url: '/summary/device/brands', activeKey: "device" },
        ].filter(Boolean),

        DeviceSummaryTopNav: [
            { name: 'Summary', icon: Organization, url: '/device-summary/summary/brands', activeKey: "summary" },
        ].filter(Boolean),

        ComparisionTopNav: [
            { name: 'Comparisions', icon: Organization, url: '/ppc-comparision/comparision/products', activeKey: "comparision" },
        ].filter(Boolean),

        PPCPerformanceTopNav: [
            { name: 'Organization', icon: Organization, url: '/performance/organization/performance', activeKey: "organization" },
        ].filter(Boolean),

        PPCOrgBottomNav: [
            { name: "Overview", url: "/ppc/organization/overview", activeKey: "overview" },
            (state.user?.user_role == 1 || state.user?.user_role == 2 || state.user?.user_role == 3) && { name: "Insights", url: "/ppc/organization/insight-matrices", activeKey: "insight-matrices" },
            // { name: "Data", url: "/ppc/organization/data", activeKey: "data" },
            // { name: "Services", url: "/ppc/organization/services", activeKey: "services" },
            // { name: "Brands", url: "/ppc/organization/brands", activeKey: "brands" },
            // { name: "Devices", url: "/ppc/organization/devices", activeKey: "devices" },
            // { name: "Performance", url: "/ppc/organization/performance", activeKey: "performance" },
        ].filter(Boolean),

        PPCDataOrgBottomNav: [
            // { name: "Overview", url: "/ppc/organization/overview", activeKey: "overview" },
            { name: "Daily Data", url: "/ppc-data/organization/data", activeKey: "data" },
            { name: "Services", url: "/ppc-data/organization/services", activeKey: "services" },
            { name: "Brands", url: "/ppc-data/organization/brands", activeKey: "brands" },
            { name: "Devices", url: "/ppc-data/organization/devices", activeKey: "devices" },
            { name: "Platforms", url: "/ppc-data/organization/platforms", activeKey: "platforms" },
            { name: "Website Performance", url: "/ppc-data/organization/website-performance", activeKey: "website-performance" },
            // { name: "Platform Performance", url: "/ppc-data/organization/platform-performance", activeKey: "platform-performance" }
            { name: "Device Performance", url: "/ppc-data/organization/device-performance", activeKey: "device-performance" }
            // { name: "Performance", url: "/ppc/organization/performance", activeKey: "performance" },
        ].filter(Boolean),

        SummaryBottomNav: [
            { name: "Products", url: "/summary/product/products", activeKey: "products" },
        ].filter(Boolean),

        PlatformSummaryBottomNav: [
            { name: "Platforms", url: "/summary/platform/platforms", activeKey: "platforms" },
        ].filter(Boolean),

        DeviceSummaryBottomNav: [
            { name: "Website", url: "/summary/device/brands", activeKey: "brands" },
            { name: "Products", url: "/summary/device/products", activeKey: "products" }
        ].filter(Boolean),

        ComparisionBottomNav: [
            { name: "Products", url: "/ppc-comparision/comparision/products", activeKey: "products" },
            { name: "Websites", url: "/ppc-comparision/comparision/websites", activeKey: "websites" },
        ].filter(Boolean),

        PPCPerformanceOrgBottomNav: [
            { name: "Performance By Month", url: "/performance/organization/performance", activeKey: "performance" },
            (state?.user?.mainRole == "admin" || state.user?.mainRole == "lead") && { name: "Performance By User", url: "/performance/organization/user-performance", activeKey: "user-performance" },
        ].filter(Boolean),

        SettingTopNav: [
            { name: 'Organization', icon: Organization, url: '/setting/organization/brands', activeKey: "organization" },
        ].filter(Boolean),

        SettingOrgBottomNav: [
            { name: "Brands", url: "/setting/organization/brands", activeKey: "brands" }
        ].filter(Boolean),
    };
    return navList
}

export default useNav